import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { PolicyVersionFormComponent } from './policy-version-form.component';
import { DxRadioGroupComponent } from 'devextreme-angular';

import { FileVersionByChangedNumberPipe } from './file-version-by-changed-number.pipe';

@NgModule({
  declarations: [PolicyVersionFormComponent, FileVersionByChangedNumberPipe],
  imports: [CommonModule, SharedModule, DxRadioGroupComponent],
  exports: [PolicyVersionFormComponent, FileVersionByChangedNumberPipe],
})
export class PolicyVersionFormModule {}
